import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/bei.png';
const _withScopeId = n => (_pushScopeId("data-v-50d01380"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer"
};
const _hoisted_2 = {
  class: "max-width content flex"
};
const _hoisted_3 = {
  class: "nav flex fs-14"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "href",
  style: {
    "display": "flex"
  }
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "flex-shrink": "0"
  }
}, "友情链接:", -1));
const _hoisted_7 = ["href"];
const _hoisted_8 = {
  key: 0,
  class: "no-padding clearfix no-margin"
};
const _hoisted_9 = {
  class: "fs-14 concat"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 电子信箱：daxzgh@163.com", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fs-16 copyright"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn",
  rel: "noreferrer",
  target: "_blank"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" 赣ICP备2023004446号-1")])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nav, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      onClick: $event => $setup.toNav(item)
    }, _toDisplayString(item.name), 9, _hoisted_4);
  }), 128))]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.urls, (item, index) => {
    return _openBlock(), _createElementBlock("a", {
      href: item.url,
      style: {
        "display": "inline-block",
        "margin-bottom": "4px",
        "margin-left": "10px",
        "color": "white",
        "text-decoration": "none"
      }
    }, _toDisplayString(item.name), 9, _hoisted_7);
  }), 256))]), false ? (_openBlock(), _createElementBlock("ul", _hoisted_8)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("span", null, "联系地址：" + _toDisplayString(_ctx.info.address), 1), _hoisted_10, _createElementVNode("span", null, " 联系电话：" + _toDisplayString(_ctx.info.tel), 1)]), _hoisted_11])]);
}